module.exports = __webpack_public_path__ + "img/genshin.30ff533.png";